import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import authReducer from '../features/authSlice';
import { authApi } from '../features/authApi';
import topbarReducer from '../features/topbarSlice';
import redirectPageReducer from '../features/verifyRedirectPageSlice';
import toastReducer from '../features/toastSlice';
import walletReducer from '../features/walletSlice';
import filterReducer from '../features/filterSlice';

// combine reducers to use in redux-persist
const reducer = combineReducers({
  pageName: redirectPageReducer,
  auth: authReducer,
  topbar: topbarReducer,
  toast: toastReducer,
  wallet: walletReducer,
  filter: filterReducer,
  [authApi.reducerPath]: authApi.reducer,
});

// Use redux persist to save data when page refreshed
// const persisterReducer = persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware),
});

setupListeners(store.dispatch);
